import clsx from 'clsx'

export interface OrderDividerProps {
  className?: string
}
export const OrDivider = ({className}: OrderDividerProps) => {
  return <div className={clsx('or-divider', className)}>OR</div>
}
